<div class="tab-content">
	<div class="px-5 py-4">
		<form #saveSiteBatteryUtilizationSettings="ngForm" (ngSubmit)="saveBatteryUtilizationSettings()" [validate-form]="'batteries_utilization_settings'">
			<div class="tab-pane fade show active" id="battery_utilization">
				<div class="row mb-4">
					<label for="daily_operating_minutes" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_battery_operating_minutes' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field"
							type="number"
							[step]="BatteriesSettingsStepValue.min_daily_battery_operating_minutes"
							min="0"
							name="min_daily_battery_operating_minutes"
							[(ngModel)]="batteryUtilizationSettings.min_daily_battery_operating_minutes"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.minutes" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="daily_charge_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_battery_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.min_daily_battery_utilization"
							min="0"
							max="100"
							name="min_daily_battery_utilization"
							[(ngModel)]="batteryUtilizationSettings.min_daily_battery_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_battery_soc" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_battery_soc' | translate }}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field"
							type="number"
							[step]="BatteriesSettingsStepValue.min_daily_battery_soc"
							min="0"
							max="100"
							name="min_daily_battery_soc"
							[(ngModel)]="batteryUtilizationSettings.min_daily_battery_soc"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_battery_energy_utilization" class="col-4 font-weight-bold">{{'site_utilization_settings.min_battery_energy_utilization' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.min_battery_energy_utilization"
							min="0"
							max="100"
							name="min_battery_energy_utilization"
							[(ngModel)]="batteryUtilizationSettings.min_battery_energy_utilization"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_battery_ah_return" class="col-4 font-weight-bold">{{'site_utilization_settings.min_battery_ah_return' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.min_battery_ah_return"
							min="75"
							max="100"
							name="min_battery_ah_return"
							[(ngModel)]="batteryUtilizationSettings.min_battery_ah_return"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.percentage_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="max_battery_low_water_level_days" class="col-4 font-weight-bold">{{'site_utilization_settings.max_battery_low_water_level_days' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.max_battery_low_water_level_days"
							min="1"
							name="max_battery_low_water_level_days"
							[(ngModel)]="batteryUtilizationSettings.max_battery_low_water_level_days"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="max_missed_weekly_wq" class="col-4 font-weight-bold">{{'site_utilization_settings.max_missed_weekly_wq' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.max_missed_weekly_wq"
							min="1"
							name="max_missed_weekly_wq"
							[(ngModel)]="batteryUtilizationSettings.max_missed_weekly_wq"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.opportunities_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="weak_cell_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.weak_cell_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="weak_cell_voltage_limit"
							[(ngModel)]="batteryUtilizationSettings.weak_cell_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.vpc_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="no_of_inuse_cycles_with_vpc_less_weak_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.no_of_inuse_cycles_with_vpc_less_weak_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="no_of_inuse_cycles_with_vpc_less_weak_voltage_limit"
							[(ngModel)]="batteryUtilizationSettings.no_of_inuse_cycles_with_vpc_less_weak_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cycles" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="deep_discharge_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.deep_discharge_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field"
							[step]="BatteriesSettingsStepValue.deep_discharge_voltage_limit"
							type="number"
							min="1"
							name="deep_discharge_voltage_limit"
							[(ngModel)]="batteryUtilizationSettings.deep_discharge_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.vpc_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="no_of_inuse_cycles_with_vpc_less_deep_discharge_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.no_of_inuse_cycles_with_vpc_less_deep_discharge_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="no_of_inuse_cycles_with_vpc_less_deep_discharge_limit"
							[(ngModel)]="batteryUtilizationSettings.no_of_inuse_cycles_with_vpc_less_deep_discharge_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cycles" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="min_finish_charge_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.min_finish_charge_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="min_finish_charge_voltage_limit"
							[(ngModel)]="batteryUtilizationSettings.min_finish_charge_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.vpc_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="no_of_charge_cycles_with_vpc_less_min_finish_charge_voltage_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.no_of_charge_cycles_with_vpc_less_min_finish_charge_voltage_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="no_of_charge_cycles_with_vpc_less_min_finish_charge_voltage_limit"
							[(ngModel)]="batteryUtilizationSettings.no_of_charge_cycles_with_vpc_less_min_finish_charge_voltage_limit"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.cycles" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4" *ngIf="!hasLithiumDevices">
					<label for="min_charge_event_duration" class="col-4 font-weight-bold">{{'site_utilization_settings.min_charge_event_duration' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="min_charge_event_duration"
							[(ngModel)]="batteryUtilizationSettings.min_charge_event_duration"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.minutes" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="geofence_distance" class="col-4 font-weight-bold">{{'site_utilization_settings.geofence_distance' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							[step]="BatteriesSettingsStepValue.geofence_distance"
							min="0"
							name="geofence_distance"
							[(ngModel)]="batteryUtilizationSettings.geofence_distance"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.ft_unit" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="low_temperature_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.low_temperature_limit' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							name="low_temperature_limit"
							[(ngModel)]="lowTemp"
							(input)="validateInputs()"
							(ngModelChange)="onLowTempInputChange($event)"
						>
						<span class="input-group-addon">
							<span *ngIf="batteryUtilizationSettings.temperature_unit != 1">{{"g.temperature_unit" | translate}}</span>
							<span *ngIf="batteryUtilizationSettings.temperature_unit == 1">{{"g.temperature_unit_c" | translate}}</span>
						</span>
					</div>
				</div>
				<div class="row mb-4">
						<label for="maximum_low_temperature_days" class="col-4 font-weight-bold">{{'site_utilization_settings.maximum_low_temperature_days' | translate}}</label>
						<div class="col-8 d-flex">
							<input class="form-control input-field" 
								type="number"
								min="1"
								name="maximum_low_temperature_days"
								[(ngModel)]="batteryUtilizationSettings.maximum_low_temperature_days"
								(input)="validateInputs()"
							>
							<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
						</div>
					</div>
				</div>
				<div class="row mb-4">
						<label for="high_temperature_limit" class="col-4 font-weight-bold">{{'site_utilization_settings.high_temperature_limit' | translate}}</label>
						<div class="col-8 d-flex">
							<input class="form-control input-field" 
								type="number"
								name="high_temperature_limit"
								[step]="BatteriesSettingsStepValue.high_temperature_limit"
								[(ngModel)]="highTemp"
								(input)="validateInputs()"
								(ngModelChange)="onHighTempInputChange($event)"
							>
							<span class="input-group-addon">
								<span *ngIf="batteryUtilizationSettings.temperature_unit != 1">{{"g.temperature_unit" | translate}}</span>
								<span *ngIf="batteryUtilizationSettings.temperature_unit == 1">{{"g.temperature_unit_c" | translate}}</span>
							</span>
						</div>
				</div>
				<div class="row mb-4">
					<label for="maximum_high_temperature_days" class="col-4 font-weight-bold">{{'site_utilization_settings.maximum_high_temperature_days' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="maximum_high_temperature_days"
							[(ngModel)]="batteryUtilizationSettings.maximum_high_temperature_days"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.days" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_plug_ins" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_plug_ins' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="1"
							name="min_daily_plug_ins"
							[(ngModel)]="batteryUtilizationSettings.min_daily_plug_ins"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.number" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4">
					<label for="min_daily_plug_time" class="col-4 font-weight-bold">{{'site_utilization_settings.min_daily_plug_time' | translate}}</label>
					<div class="col-8 d-flex">
						<input class="form-control input-field" 
							type="number"
							min="0"
							[step]="BatteriesSettingsStepValue.min_daily_plug_time"
							name="min_daily_plug_time"
							[(ngModel)]="batteryUtilizationSettings.min_daily_plug_time"
							(input)="validateInputs()"
						>
						<span class="input-group-addon"><span>{{"g.minutes" | translate}}</span></span>
					</div>
				</div>
				<div class="row mb-4 align-items-center">
					<label for="charging_type" class="col-4 font-weight-bold mb-0"> {{ 'site_settings.charging_type' | translate }}</label>
					<div class="col-8 d-flex align-items-center" role="group">
						<input
							type="radio"
							class="btn-check"
							id="conventional"
							name="charging_type"
							[(ngModel)]="batteryUtilizationSettings.charging_type"
							[value]="ChargingType.CONVENTIONAL"
						/>
						<label class="px-2 mb-0" for="conventional"> {{ 'g.conventional' | translate }} </label>

						<input
							type="radio"
							class="btn-check ml-2"
							id="opportunityFast"
							name="charging_type"
							[(ngModel)]="batteryUtilizationSettings.charging_type"
							[value]="ChargingType.OPPORTUNITY_FAST"
						/>
						<label class="px-2 mb-0" for="opportunityFast"> {{ 'site_settings.opportunity_fast_charging' | translate }} </label>
					</div>
				</div>
				<div class="row mb-4">
					<label for="site_operating_work" class="col-4 font-weight-bold">{{'site_utilization_settings.site_operating_work' | translate}}</label>
					<div class="col-8 d-flex">
						<div class="form-check form-check-inline" *ngFor="let day of workingDays; let dayIndex = index;">
							<input type="checkbox" class="form-check-input input-field" 
								[value]="day.id"
								[id]="'workingDay-' + dayIndex"
								[checked]="isChecked(day.id)"
								(change)="onCheckboxChange(day.id, $event.target.checked)"
								name="workingDays-{{dayIndex}}"
							>
							<label class="form-check-label" [for]="'workingDay-' + dayIndex">{{ day.label }}</label>
						</div>
					</div>
				</div>
			<div class="row my-4 align-items-center">
				<div class="col-md-4">
				</div>
				<div class="col-md-8">
					<div class="row align-items-center">
						<div class="col-md-8">
							<button type="submit" [disabled]="disableButton" class="btn text-white main-blue-bg btn-lg col-5 mr-4">{{'g.save' | translate}}</button>
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
</div>